import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.element.querySelector("[data-action='qr-toggle#toggle']")?.setAttribute("aria-expanded", "false")
  }

  toggle(event) {
    this.panelTarget.classList.toggle("hidden")
    const isOpen = !this.panelTarget.classList.contains("hidden")
    event.currentTarget.setAttribute("aria-expanded", isOpen.toString())

    if (isOpen) {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
      this.panelTarget.scrollIntoView({ block: "nearest", behavior: reduceMotion ? "auto" : "smooth" })
    }
  }
}
